import Create from '../../../base/forms/user/Create';

const create: Create = {
  header: 'Add new user',
  submit: 'Add'
};

export default create;
